// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const TimeOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M59.32 61.681a2 2 0 0 0 .266-2.816l-9.584-11.58V27.843a2 2 0 0 0-4 0v20.164a2 2 0 0 0 .459 1.275l10.043 12.134c.395.478.966.725 1.542.725.449 0 .901-.15 1.274-.46m-11.318-45.18C30.632 16.5 16.5 30.634 16.5 48.007c0 17.364 14.132 31.492 31.502 31.492C65.37 79.5 79.5 65.373 79.5 48.007 79.5 30.634 65.37 16.5 48.002 16.5m0 66.998C28.425 83.5 12.5 67.578 12.5 48.008 12.5 28.429 28.425 12.5 48.002 12.5 67.575 12.5 83.5 28.429 83.5 48.007c0 19.57-15.925 35.492-35.498 35.492"
			fillRule="evenodd"
		/>
	</svg>
);
export default TimeOutline;
